import { render, staticRenderFns } from "./ContentDiscoveryMenu.vue?vue&type=template&id=1c8cf951&scoped=true&"
import script from "./ContentDiscoveryMenu.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiscoveryMenu.vue?vue&type=style&index=0&id=1c8cf951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cf951",
  null
  
)

export default component.exports